﻿var news = (function () {
    var maxClips, shownClips;
    return {
        init: function () {
            maxClips = $('[data-idx]').length;
            shownClips = $('[data-idx]:visible').length;
            $('[data-loadmore]').on('click', function (e) {
                e.stopImmediatePropagation();
                shownClips += 4;
                if (shownClips >= maxClips) {
                    shownClips = maxClips;
                    $('[data-loadmore]').hide();
                }
                $('[data-idx]').each(function (i, e) {
                    if (i < shownClips) {
                        $(e).fadeIn();
                    }
                });
                return false;
            });
        }
    };
})();
$(document).ready(function () {
    // only init if the control is on this page
    if ($('[data-newsrollup]').length > 0) {
        news.init();
    }
});